// extracted by mini-css-extract-plugin
export const header = "portfolio-module--header--UODYX";
export const body = "portfolio-module--body--jaBbb";
export const related = "portfolio-module--related--3yRYH";